import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5940c3f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "CURRENT COURSES", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { inject, onBeforeMount, ref, reactive } from 'vue'
    import PageHeader from '@/components/PageHeader.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseView',
  setup(__props) {

    const $axios : any = inject('axios');

    let table = ref([]);

    onBeforeMount(() => {
      $axios.get('/courses/all').then((res: any) => {
        table.value = res.data;
      });
    });

    const data = reactive(
      {
        table:table,
        rootPath:'/education',
        root:'Education',
        current:'current courses',
        currentPath:'/course',
        inquiryPath:'/contact/student',
        isPara:false,
        isTable:true
      }
    );


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(PageHeader, { value: data }, null, 8, ["value"]),
    _hoisted_3
  ]))
}
}

})